// libs
import { SerializedStyles } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

export const Container = styled.main<{ isSubMenuVisible: boolean }>`
  ${({ theme, isSubMenuVisible }) => `
  margin: ${isSubMenuVisible ? `calc(${theme.spacing.spacing240} + ${theme.spacing.spacing40})` : 0} auto;
  `};
`;

export const AppLayoutContainer = styled.div<{ cssProps?: (boolean | SerializedStyles)[] }>`
  ${({ cssProps }) => cssProps}
`;
